export default __webpack_public_path__ + "static/media/cbcSala4.61e8aceb.jpg";